import 'jquery';

export default {
    ready() {
        jQuery("#header-md-hours").hide();
        jQuery("#header-btn-hours").click( function(){
            jQuery("#header-md-hours").slideToggle(100);
        });

        jQuery('#btn-menu').click(function(event) {
            jQuery('#sliding-nav').addClass('active');
        });

        jQuery('#sliding-nav').click(function(event) {
            jQuery('#sliding-nav').removeClass('active');
        });

        jQuery('#desktop-nav ul li').mouseleave(function(event) {
            if (jQuery(this).children('ul').length > 0) {
            jQuery(this).children('ul').removeClass('sub-menu-open');
            jQuery(this).children('.header-lineup-container').removeClass('sub-menu-open');
            //event.stopPropagation();
            event.preventDefault();
            }
        });
        jQuery('#desktop-nav ul:not(.sub-menu) > li').mouseover(function(event) {
            if (jQuery(this).children('ul').length > 0) {
                
            jQuery(this).children('ul').addClass('sub-menu-open');
            jQuery(this).children('.header-lineup-container').addClass('sub-menu-open');
            event.stopPropagation();
            event.preventDefault();
            }
        });
        jQuery('#desktop-nav ul.sub-menu > li').mouseover(function(event) {
            if (jQuery(this).children('ul').length > 0) {
            jQuery(this).children('ul').addClass('sub-menu-open');
            jQuery(this).children('ul').css("margin-left", "30px");
            event.stopPropagation();
            event.preventDefault();
            }
        });
        
        jQuery('#side-nav ul li, #sliding-nav #desktop-nav-mobile ul li, #sliding-nav #desktop-nav-vertical ul li').unbind('click').click(function(event) {
          jQuery(this).children('ul').children('li').click(function(event) {
                if(jQuery(this).children('ul').length == 0 ){
                    jQuery('#sliding-nav').removeClass('active')
                    event.stopPropagation();
                    return;
                }
            });

            if (jQuery(this).children('ul').length > 0 && jQuery(this).children('ul').hasClass('sub-menu-open')) {
                jQuery(this).children('ul').removeClass('sub-menu-open');
                event.stopPropagation();
                event.preventDefault();

            } else if (jQuery(this).children('ul').length > 0) {
                jQuery('#side-nav ul li, #sliding-nav #desktop-nav-mobile ul li, #sliding-nav #desktop-nav-vertical ul li').not(this).children("ul").removeClass('sub-menu-open');
                jQuery(this).parent().addClass('sub-menu-open');
                jQuery(this).children('ul').addClass('sub-menu-open');
                event.stopPropagation();
                event.preventDefault();
            }
        });

        /* Close on orientation change */
        $( window ).on("orientationchange", function( event ) {
          jQuery('#sliding-nav').removeClass('active');
        });

        /* Omnisearch */
        jQuery(".header-search-btn, .close-search-svg").on("click", function(){
            jQuery("#header-omnisearch").animate({width: 'toggle'});
            jQuery("#search").focus();
            if(jQuery("#section-buttons").hasClass("active")){
              jQuery("#section-buttons").removeClass("active");
              
              if(window.screen.width >= 1024)
                jQuery(".header-next-to-omnisearch-hook").fadeIn("slow");
            
              }else{
                jQuery("#section-buttons").addClass("active")
                
                if(window.screen.width >= 1024)  
                  jQuery(".header-next-to-omnisearch-hook").fadeOut("slow");
            }
        });

        /* Megamenu */
        jQuery(".header-burger-btn").on("click", function(){
          if(jQuery("#header-mm").hasClass("invisible")){
            jQuery("#header-mm").removeClass("invisible opacity-0");
            jQuery("#header-mm").addClass("visible opacity-100");
            jQuery(".header-burger-btn").addClass("active");
          }
          else{
            jQuery("#header-mm").addClass("invisible opacity-0");
            jQuery("#header-mm").removeClass("visible opacity-100");
            jQuery(".header-burger-btn").removeClass("active");
          }
        });

        /* Click outside to close side menu */
        $(document).mouseup(function(e){
          let container = $("#header-mm");
          let menuBtn = $(".header-burger-btn");
          
          // If the target of the click isn't the container
          if(!container.is(e.target) && container.has(e.target).length === 0 && !menuBtn.is(e.target) && menuBtn.has(e.target).length === 0 && !jQuery("#header-mm").hasClass("invisible")){
            jQuery("#header-mm").addClass("invisible opacity-0");
            jQuery("#header-mm").removeClass("visible opacity-100");
            jQuery(".header-burger-btn").removeClass("active");
            jQuery("#ch-burguer").prop("checked",false);
          }
        });

    jQuery('#side-nav .sub-menu a').on('click', function (event) {
      if (jQuery(this).attr('target') != '_blank') {
        window.location.href = jQuery(this).attr('href');
      }
      else {
        window.open(jQuery(this).attr('href'), '_blank').focus();
      }
        });
    }
}
